import {de_DE_formal} from './de_DE-formal';
import {de_DE_base} from './de_DE-base';

export const dbconnect_de = {
    ...de_DE_formal,
    ...de_DE_base,
}
